import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import mockData from '../mock';

const SolutionSection = () => {
  const { solution } = mockData;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {solution.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {solution.description}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {solution.steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < solution.steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-1 bg-gradient-to-r from-orange-500 to-yellow-400 z-0"></div>
              )}

              {/* Card */}
              <div className="relative bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl p-6 card-hover border border-orange-200">
                {/* Step Number */}
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-full flex items-center justify-center mb-4 shadow-lg">
                  <span className="text-white font-bold text-2xl">{step.step}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 bg-green-100 rounded-full px-6 py-3">
            <CheckCircle2 className="w-6 h-6 text-green-600" />
            <span className="text-green-800 font-semibold text-lg">
              Zero electricity bill guaranteed!
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;